// ** React Imports
import Billing from '../../views/pages/Billing';
import ContactUs from "../../views/pages/ContactUs";
import AccountSettings from '../../views/Profile';

// Fraud Detection
import APIKey from '../../views/APIKey';
import BatchUpload from '../../views/DocumentForgery/batchAnalysis/batchUpload';
import BatchHistory from '../../views/DocumentForgery/batchAnalysis/batchHistory';
import BatchResult from '../../views/DocumentForgery/batchAnalysis/batchResult';

// APIs
import SuccessPage from '../../views/pages/Status/SuccessPage';
import FailurePage from '../../views/pages/Status/FailurePage';
import DocumentForgery from '../../views/DocumentForgery';
import DocumentAnalysis from '../../views/DocumentForgery/analysis/DocumentAnalysis';

import UploadHistory from '../../views/DocumentForgery/history/UploadHistory';

const AppRoutes = [
  {
    path: '/dashboard',
    element: <DocumentForgery />,
    meta: { publicRoute: false }
  },
  {
    path: '/document-forgery/:step',
    element: <DocumentForgery />,
    meta: { publicRoute: false }
  },
  {
    path: '/history/',
    element: <UploadHistory />,
    meta: { publicRoute: false }
  },
  {
    path: '/batch-upload',
    element: <BatchUpload />,
    meta: { publicRoute: false }
  },
  {
    path: '/batch-upload/history',
    element: <BatchHistory />,
    meta: { publicRoute: false }
  },
  {
    path: '/batch-result/:batchId',
    element: <BatchResult />,
    meta: { publicRoute: false }
  },
  {
    path: '/dashboard/analysis/:analysisId',
    element: <DocumentAnalysis />,
    meta: { publicRoute: false }
  },
  {
    path: '/pages/account-settings',
    element: <AccountSettings />
  },
  {
    element: <Billing />,
    path: '/billing',
    meta: { publicRoute: false }
  },
  {
    element: <ContactUs />,
    path: '/support',
    meta: { publicRoute: false }
  },
  {
    path: '/apis',
    element: <APIKey />,
    meta: { publicRoute: false }
  },
  {
    path: '/pages/account-settings',
    element: <AccountSettings />
  },
  //status
  {
    path: '/success',
    element: <SuccessPage />,
    meta: { publicRoute: false }
  },
  {
    path: '/payment-failed',
    element: <FailurePage />,
    meta: { publicRoute: false }
  },
]

export default AppRoutes;
